import React, { useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetAuth } from '../../hooks/useAuth';
import { useSetAuth } from '../../hooks/useAdminAuth';
import { UserContext } from '../../App';
import Loader from '../Loader';
import AuthLinkError from '../AuthLinkError';

export default function ValidateAuth() {
  const user = useContext(UserContext);
  const params = useParams();
  const navigate = useNavigate();
  const { data, isError, error } = useGetAuth(params.token);

  useSetAuth(data);

  useEffect(() => {
    // when the user matches the getauth payload
    // localstorage and user state persistence is complete
    if (data && data.data?.data?.attributes?.email === user.user.email) {
      const authState = JSON.parse(window.localStorage.getItem('auth'));
      // hard redirect to clear out any admin state
      // wait for localstorage to reflect changes
      if (authState.data?.data?.attributes?.email === user.user.email) {
        navigate('/admin');
        //window.location.pathname = '/admin'
      }
    }
  }, [user, data, navigate]);

  if (isError) {
    return <AuthLinkError error={error} to="/admin/cashiers" label="Back to cashier login" />;
  }

  return <Loader />;
}
